import jsonFromDocument from "cerulean/src/JsonFromDocument";

// FIs get access to an English-only copy editor version of the editor when the "copyeditor" flag is enabled.
//
// The "multilingual" flag must be enabled to view and edit messages for non-English languages.
//
// Narmi internal users get full permissions.
const useTranslationPermissions = () => {
  const isNarmi = jsonFromDocument("current_user")?.is_narmi || false;
  const features = Object.entries(jsonFromDocument("institution_features"))
    .filter(([, value]) => value)
    .map(([key]) => key);
  return {
    isNarmi, // Whether the current user is a Narmi internal user
    addLanguage: isNarmi, // Add a non-English language to a product
    removeLanguage: isNarmi, // Remove a non-English language from a product
    statusChange: features.includes("multilingual") || isNarmi, // Enable or disable a language in a product
    cleanFtl: isNarmi, // Clean/format FTL files
    editRaw: isNarmi, // Edit raw translation files
    viewRaw: isNarmi, // View raw translation files
    editOtherMessage: features.includes("multilingual") || isNarmi, // Edit non-English messages
    editEnglishMessage: features.includes("copyeditor") || isNarmi, // Edit English messages
  };
};

export default useTranslationPermissions;
